module.exports = __webpack_public_path__ + "img/266-3.9ffe95a8.png";